import { notifications } from "@mantine/notifications";
import { IconCheck } from "@tabler/icons-react";

export function SuccessNotification(description: string) {
  notifications.show({
    title: "Success",
    message: description,
    color: "green",
    icon: <IconCheck />
  });
}
